import axios from 'axios';

import { ISubmissionAnalyticsPayload } from '../../AnalyticsService';

export const getRTRAnalyticsInPostgre = (
  searchQuery: ISubmissionAnalyticsPayload,
  abortController: AbortController
) => axios.post(`/corphiringservice/api/rtr/composable-analytics`, searchQuery, abortController);
